import {
  REGISTER,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  AUTH_ERROR,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_WITH_CODE,
  LOGOUT,
  REQUEST_RESET_EMAIL,
  REQUEST_RESET_EMAIL_SUCCESS,
  REQUEST_RESET_EMAIL_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  GET_FREE_TRIAL_STATUS,
  GET_FREE_TRIAL_STATUS_SUCCESS,
  GET_FREE_TRIAL_STATUS_ERROR,
  REDEEM_FREE_TRIAL,
  REDEEM_FREE_TRIAL_SUCCESS,
  REDEEM_FREE_TRIAL_ERROR,
} from './constants';

export function register({ name, lastName, email, password, callback }) {
  return {
    type: REGISTER,
    name,
    lastName,
    email,
    password,
    callback,
  };
}

export function registerSuccess(payload) {
  return {
    type: REGISTER_SUCCESS,
    payload,
  };
}

export function registerError(errors) {
  return {
    type: REGISTER_ERROR,
    errors,
  };
}

export function requestResetEmail(email) {
  return {
    type: REQUEST_RESET_EMAIL,
    email,
  };
}

export function requestResetEmailSuccess(payload) {
  return {
    type: REQUEST_RESET_EMAIL_SUCCESS,
    payload,
  };
}

export function requestResetEmailError(errors) {
  return {
    type: REQUEST_RESET_EMAIL_ERROR,
    errors,
  };
}

export function resetPassword({ email, token, newPassword }) {
  return {
    type: RESET_PASSWORD,
    email,
    token,
    newPassword,
  };
}

export function resetPasswordSuccess(payload) {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload,
  };
}

export function resetPasswordError(errors) {
  return {
    type: RESET_PASSWORD_ERROR,
    errors,
  };
}

export function loadUser() {
  return {
    type: LOAD_USER,
  };
}

export function loadUserSuccess(payload) {
  return {
    type: LOAD_USER_SUCCESS,
    payload,
  };
}

export function loadUserError(errors) {
  return {
    type: LOAD_USER_ERROR,
    errors,
  };
}

export function loginUser({ email, password, callback }) {
  return {
    type: LOGIN_USER,
    email,
    password,
    callback,
  };
}

/** Sign in with the 6-digit code from the email (success/error: loginUser*). */
export function loginWithCode({ email, code, callback }) {
  return {
    type: LOGIN_WITH_CODE,
    email,
    code,
    callback,
  };
}

export function loginUserSuccess(payload) {
  return {
    type: LOGIN_USER_SUCCESS,
    payload,
  };
}

export function loginUserError(errors) {
  return {
    type: LOGIN_USER_ERROR,
    errors,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

// Free Trial Actions
export function getFreeTrialStatus() {
  return {
    type: GET_FREE_TRIAL_STATUS,
  };
}

export function getFreeTrialStatusSuccess(payload) {
  return {
    type: GET_FREE_TRIAL_STATUS_SUCCESS,
    payload,
  };
}

export function getFreeTrialStatusError(errors) {
  return {
    type: GET_FREE_TRIAL_STATUS_ERROR,
    errors,
  };
}

export function redeemFreeTrial(callback) {
  return {
    type: REDEEM_FREE_TRIAL,
    callback,
  };
}

export function redeemFreeTrialSuccess(payload) {
  return {
    type: REDEEM_FREE_TRIAL_SUCCESS,
    payload,
  };
}

export function redeemFreeTrialError(errors) {
  return {
    type: REDEEM_FREE_TRIAL_ERROR,
    errors,
  };
}
